import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@UILibrary/Button'
import { Table } from "@UILibrary/Table"
import { track } from '@utils/tracking'
import { Card, CardContent } from '@components/layout/Card'
import Http from '@shared/http'
import styles from './data-access-table.module.sass'

const handleRemoveAccess = async (id, params, dataAccess, setDataAccess) => {
  track('Client removed service user access')
  Http.request(`/api/service_assignments/${params.id}`, "DELETE").then((response) => {
    if (response.ok) {
      setDataAccess(dataAccess.filter(access => access.id !== id))
    } else {
      alert('Failed to remove access. Please contact support.')
    }
  }, () => {
    alert('Failed to remove access. Please contact support.')
  })
}

const getActionHandler = (actionType) => {
  switch (actionType) {
    case 'remove_access':
      return handleRemoveAccess;
    default:
      return null;
  }
}

export const DataAccessTable = ({ dataAccess: initialDataAccess }) => {
  const [dataAccess, setDataAccess] = useState(initialDataAccess)

  if (!dataAccess.length) {
    return (
      <Card className={styles.dataAccessCard}>
        <CardContent className={styles.tableCardContent}>
          <p className={styles.noAccessMessage}>There are no other users that have access to your data.</p>
        </CardContent>
      </Card>
    )
  }

  const handleActionClick = (actionType, id, params) => {
    const actionHandler = getActionHandler(actionType)
    if (actionHandler) {
      if (window.confirm('Are you sure?')) {
        actionHandler(id, params, dataAccess, setDataAccess)
      }
    }
  }

  const data = dataAccess.map((access) => ({
    access: access.accessType,
    action: { actionText: access.actionText, id: access.id, actionType: access.actionType, actionParams: access.actionParams },
    individual: { name: access.name, role: access.role },
    organisation: access.organization,
  }))

  const tableColumns = [
    { label: 'Individual', key: 'individual', render: ({ individual }) => (
      <>
        <p className={styles.individualName}>{individual.name}</p>
        <p className={styles.individualRole}>{individual.role}</p>
      </>
    )},
    { label: 'Organisation', key: 'organisation', render: ({ organisation }) => organisation   },
    { label: 'Access', key: 'access', render: ({ access }) => access },
    {
      label: '', key: 'action', render: ({ action: { actionText, id, actionType, actionParams }}) => {
        if (!actionText) { return null }

        return (
          <Button
            variant="destructive"
            size="small"
            onClick={() => handleActionClick(actionType, id, actionParams)}
          >
            {actionText}
          </Button>
        )
      }
    }
  ]

  return (
    <Card className={styles.dataAccessCard}>
      <CardContent className={styles.tableCardContent}>
        <Table
          data={data}
          columns={tableColumns}
          itemsPerPage={25}
          className={styles.dataAccessTable}
        />
      </CardContent>
    </Card>
  )
}

DataAccessTable.propTypes = {
  dataAccess: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      accessType: PropTypes.string.isRequired,
      actionParams: PropTypes.object,
      actionText: PropTypes.string,
      actionType: PropTypes.string,
      name: PropTypes.string.isRequired,
      organization: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
    })
  ).isRequired,
}
